import { AfterViewInit, Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { config } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { TranslateService } from '@ngx-translate/core';
import { FormService } from '../../services/form.service';

@Component({
    selector: 'app-form-field-radio-button-v2',
    templateUrl: './form-field-radio-button-v2.component.html',
    styleUrls: ['./form-field-radio-button-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldRadioButtonV2Component implements OnInit, AfterViewInit {

  @Input() configData;
  @Input() frmGroup : UntypedFormGroup;

  disabled : boolean = false;
  userAccess;
  checkedBtnVal: any;
  radiobuttons: string[];
  constructor(private formService: FormService,private appService: AppService, public translate: TranslateService) { }

  ngOnInit() {
    this.disabled = this.configData.disabled;
    this.frmGroup.get(this.configData.name)['hidden']=this.configData.validation.includes('hidden') ? true:false;
    this.radiobuttons = this.configData.options;
    this.checkedBtnVal = this.frmGroup.get(this.configData.name).value;
    if (this.frmGroup.get(this.configData.name).value === '' || this.frmGroup.get(this.configData.name).value === null || this.frmGroup.get(this.configData.name).value === undefined) {
      this.frmGroup.get(this.configData.name).setValue(false);
    }
    if (this.frmGroup.get(this.configData.name).value) {
      let name = this.configData.name;
      if (this.configData['relatedColumns']) {
        this.configData['relatedColumns'].forEach(element => {
          if (element.key === this.frmGroup.get(this.configData.name).value) {
            let fieldEvent = [];
            let reqEvent=[];
            element?.requiredList?.forEach(r => {
              reqEvent.push(r);
            })
            element.value.forEach(field => {
              fieldEvent.push(field);
            })
            this.formService.setEvent({ 'visibility': true, 'name': name, 'eventList': fieldEvent,'requiredList': reqEvent ,keepValue:true });
          }
        });
      }
    }
    // CP-8121 - START: External user should not be able to see the "Scheduled" button on the quote screen. Radio Button hiddden from non-authorized personas
    if(this.configData['editAccess']){
      this.roleAccessValidation();
    }
    //CP - 8121 - END : External user should not be able to see the "Scheduled" button on the quote screen.Radio Button hiddden from non - authorized personas

    //#7359, 7383 : No Need this changes for forcefully make required
    // setTimeout(() => {
    //   this.frmGroup.controls[this.configData.name].setErrors({ "required": true });
    // })
  }
  ngAfterViewInit(){
    this.onCommonEventHander( 'CHANGE', null);
  }
  //CP-8121 -START: External user should not be able to see the "Scheduled" button on the quote screen. Radio Button hiddden from non-authorized personas
  roleAccessValidation() {
    if (this.configData['editAccess']) {
        this.configData['editAccess'].forEach(row => {
            let persona;
            if (row.roleAccess) {
                persona = row.roleAccess;
            } else {
                persona = row.persona;
            }
            if (row.action == 'hidden') {
                this.frmGroup.get(this.configData.name)['hidden'] = !this.checkFieldAccess(persona);
            }
        });
    }
  }

  // Check if logged in user is among the mentioned personas
  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }
  //CP-8121 -END: External user should not be able to see the "Scheduled" button on the quote screen. Radio Button hiddden from non-authorized personas
 
 onRadioBtnChange(e,data,displayValue?)
  {
    this.checkedBtnVal = data;
    this.frmGroup.get(this.configData.name).setValue(data);
        
      // let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'CHANGE');
      // if (event) {
      //   this.sendToSource(event, data);
      //   return
      // }
      this.onCommonEventHander( 'CHANGE', e)
      let name = this.configData.name;
      if (this.configData['relatedColumns']) {
        this.configData['relatedColumns'].forEach(element => {
          if (element.key === data) {
            let fieldEvent = [];
            let reqEvent=[];
            element?.requiredList?.forEach(r => {
              reqEvent.push(r);
            })
            element.value.forEach(field => {
              fieldEvent.push(field);
            })
            this.formService.setEvent({ 'visibility': true, 'name': name, 'eventList': fieldEvent,'requiredList': reqEvent , keepValue:false });
          }
        });
      }
      // if (this.configData['affectedColumns']) {
      //   this.configData['affectedColumns'].forEach(element => {
      //     if(element.type == "pattern"){
      //     if (element.key === data.value) {
      //       element.value.forEach(field => {
      //           if (!field.keepValue) {
      //             this.frmGroup.get(field.name).updateValueAndValidity();
      //           }
      //         });
      //        }
      //     }else if (element.key === data.value) {
      //       element.value.forEach(field => {
      //         let fieldName = (typeof field == 'object' ? field.name : field);
      //         this.frmGroup.get(fieldName)['hidden'] = false;
      //         this.frmGroup.get(fieldName).setValidators([Validators.required]);
      //         this.frmGroup.get(fieldName).updateValueAndValidity();
      //       })
      //     } else {
      //       element.value.forEach(field => {
      //         let fieldName = (typeof field == 'object' ? field.name : field);
      //         this.frmGroup.get(fieldName)['hidden'] = true;
      //         this.frmGroup.get(fieldName).setValidators(null);
      //         this.frmGroup.get(fieldName).updateValueAndValidity();
      //         if (!field.keepValue) {
      //           this.frmGroup.get(fieldName).reset();
      //         }
      //       })
      //     }
      //   });
      // }
    // this.sendToSource(event);
    // this.frmGroup.get(this.configData.name).setValue(data.trim());
  }

  clearFieldValue(){
    this.frmGroup.get(this.configData.name).reset();
  }

  toggleVisibility(hidden) {
    this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    if(hidden === true)
    this.frmGroup.get(this.configData.name).reset();
    if(this.configData.events && hidden === false)
    this.onCommonEventHander('CHANGE', null);
  }

  onReset(){
    if (!this.frmGroup.get(this.configData.name).value) {
      this.frmGroup.get(this.configData.name).setValue(this.configData.defaultValue.value);
    } else{
      this.frmGroup.get(this.configData.name).setValue(JSON.parse(this.frmGroup.get(this.configData.name).value));
    }
    this.onCommonEventHander('CHANGE', null);
  }

  onCommonEventHander(eventType, userEvent) {
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, eventType);
    let allow = false;
    if(event){
      allow =  (event['eventOnDisable'] === true && this.configData['disabled'] === true) || event['eventOnDisable'] === undefined;
    }
    if (this.frmGroup.get(this.configData.name).valid || allow) {
      if (event) {
        this.sendToSource(event, userEvent);
        return
      }
    }
  }

  sendToSource(event, data = {}) {
    console.log("value:::::",this.frmGroup.get(this.configData.name).value);
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.actionType || 'MULTIPLE_ACTION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: this.frmGroup.get(this.configData.name).value
    }
    console.log("eventData:::",eventData);
    this.appService._commonComponentSubject.next(eventData);
  }
  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      // event = (event.length ? event[0] : null);
      if (event.length === 1) {
        event = event[0];
      } else if (event.length > 1) {
        event = event;
      } else { event = null }
    }
    return event;
  }
}